import React from "react";
// SCSS
import "./hero.scss";
// Assets
import HeroImage from "../../assets/hero/hero-image.png";
// Components
import Button from "../ui-components/button/button";

const Hero = () => (
  <div className="hero" id="hero">
    <div className="hero-content">
      <div className="hero-image-container">
        <img src={HeroImage} alt="hero" />
      </div>
      <div className="hero-info">
        <h1 className="weight800 font60">¡Bienvenidos!</h1>
        <h2 className="weight700 font50">Creamos eventos que dejan huella.</h2>
        <p className="font16">
          Cada evento es único y especial. Nos encargamos de cada detalle para 
          que puedas disfrutar sin preocupaciones. Desde la planificación hasta 
          la ejecución, convertimos ideas en momentos inolvidables.
        </p>
      </div>
    </div>
  </div>
);

export default Hero;
